// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"Placeholder_placeholder__FJ6w5","rounded":"Placeholder_rounded__73nxe"};